var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.846 15.056-2.72-2.912a7.37 7.37 0 0 0 1.709-4.727C14.835 3.327 11.507 0 7.417 0S0 3.327 0 7.417s3.328 7.417 7.417 7.417a7.369 7.369 0 0 0 3.071-.664.57.57 0 1 0-.472-1.039A6.283 6.283 0 0 1 1.14 7.417 6.283 6.283 0 0 1 7.417 1.14a6.283 6.283 0 0 1 6.277 6.276 6.244 6.244 0 0 1-1.75 4.346.571.571 0 0 0 .016.807c.017.016.04.022.06.037.014.023.022.049.042.07l2.95 3.157a.567.567 0 0 0 .807.027.57.57 0 0 0 .027-.805Z",
    fill: "#999",
    fillRule: "nonzero"
  })));
};

export default SvgSearch;